export enum DoNotCallRestrictionType {
  LimitedHours = 'limited_hours',
  FullRestriction = 'full_restriction',
}

export enum ClinicDoNotCallRestrictionType {
  LimitedHours = 'limited_hours',
  FullRestriction = 'full_restriction',
  InheritParentClinic = 'inherit_parent_clinic',
}
